import React, { useState, useEffect, FC } from "react";
import List from "../list/list";
import SearchField from "../search-field/search-field";

import "./searchable-list.css";

type Props = {
    items: any[];
    title: string;
    onSelect: (index: number, item: any) => void;
    isStriped?: boolean;
    isMultiSelect?: boolean;
    selectedItems?: number[];
    searchBoxClassName?: string;
    titleClassName?: string;
    listClassName?: string;
    stripedListClassName?: string;
    listItemClassName?: string;
    stripedListItemClassName?: string;
    selectedListItemClassName?: string;
    onSearch?: (searchTerm) => void;
};

const SearchableList: FC<Props> = ({
    items,
    title,
    onSelect,
    isStriped = true,
    isMultiSelect = false,
    selectedItems = undefined,
    titleClassName = "mx-2 mt-2 p-1",
    listClassName = "pt-1 pr-1 pl-1",
    stripedListClassName = "p-1",
    listItemClassName,
    stripedListItemClassName,
    selectedListItemClassName,
    searchBoxClassName = "mb-4",
    onSearch,
}) => {
    const [listItems, setListItems] = useState(items);

    const buildListItem = (item, index) => {
        return { value: item, isSelected: selectedItems?.includes(index) };
    };

    useEffect(() => {
        if (!!items) {
            setListItems(items.map(buildListItem));
        }
    }, [items]);

    useEffect(() => {
        if (!!items) {
            const newItems = items.map(buildListItem);
            setListItems(newItems);
        }
    }, []);

    const handleSelect: (index: number, item: any) => void = (index, item) => {
        const listItem = listItems[index]
        const newListItems = [...listItems.slice(0, index), { ...listItem, isSelected: !listItem.isSelected }, ...listItems.splice(index + 1)];
        setListItems(newListItems);
        onSelect(index, item);
    };

    const handleSearchTermUpdate = (newSearchTerm) => {
        onSearch && onSearch(newSearchTerm);
    }

    return (
        <>
            {title ? (
                <div
                    className={`flex flex-row border text-gray-700 rounded-t ${titleClassName}`}
                >
                    <p className="p-1 text-gray-700 text-xs font-bold">
                        {title}
                    </p>
                </div>
            ) : null}
            <div
                className={`${isStriped
                    ? `text-gray-700 ${stripedListClassName}`
                    : `text-black ${listClassName}`
                    }`}
            >
                <SearchField
                    setSearchTerm={handleSearchTermUpdate}
                    className={searchBoxClassName}>
                </SearchField>
                <List
                    onSelect={handleSelect}
                    isStriped={isStriped}
                    items={listItems}
                    isMultiSelect={isMultiSelect}
                    listItemClassName={listItemClassName}
                    stripedListItemClassName={stripedListItemClassName}
                    selectedListItemClassName={selectedListItemClassName}
                />
            </div>
        </>
    );
};

export default SearchableList;
